module.exports = __webpack_public_path__ + "static/img/31.8edf049.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/31.jpg
// module id = W5XY
// module chunks = 1